import React, { Component } from 'react';
import autobind from 'class-autobind';

import TagsInput from 'zoomforth_component_lib/tags_input.jsx';

class TagsInputWithClickHandling extends Component {

  constructor() {
    super();
    autobind(this);
  }

  getTagsInputWrapper() {
    if (this.tagsInputRef) {
      return $(this.tagsInputRef.getInput()).closest('div.react-tagsinput');
    }
    return null;
  }

  handleTagsInputRefReceived(ref) {
    this.tagsInputRef = ref;
    const tagsInputWrapper = this.getTagsInputWrapper();

    // setup a click listener for the outer tagsinput div. react-tagsinput has
    // an input HTML element which grows with its content so by default
    // clicking the large input area will not focus like expected.
    if (tagsInputWrapper) {
      tagsInputWrapper.on('click', ()=> {
        if (!this.props.disabled) {
          this.tagsInputRef.focus();
        }
      });
    }
  }

  componentWillUnmount() {
    const tagsInputWrapper = this.getTagsInputWrapper();

    if (tagsInputWrapper) {
      tagsInputWrapper.off('click');
    }
  }

  render() {
    const { inputProps, ...props } = this.props;

    return (
      <TagsInput
        inputProps={{
          ref: this.handleTagsInputRefReceived,
          ...inputProps
        }}
        { ...props }
      />
    );
  }
}

export default TagsInputWithClickHandling;
